import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  fetchUserSwitchRequestData,
  handleRBACVerifyOtpRequest,
  handleSendRBACRequestOTP
} from 'store/slices';

import usePermission from 'hooks/usePermission';

import {
  objectToFormData,
  getDataFromLocalStorage,
  getUserType,
  paymentColor,
} from 'utils/helpers';

import { icons, limit, userRole } from 'utils/constants';

import Card from 'components/Layout/Card';
import Table from 'components/Layout/Table';
import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import ExportButton from 'components/Layout/ExportButton';

import UpdateSwitchUserModal from './UpdateSwitchUserModal';
import BulkAction from '../../Common/BulkAction';


const SwitchUser = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const memberType = getUserType();
  const loginUserRole = getDataFromLocalStorage('user_type');
  const { viewAccess, createAccess, updateAccess, deleteAccess } = usePermission("Requests");

  const [openEditModal, setOpenEditModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [timer, setTimer] = useState('');
  const [searchPayload, setSearchPayload] = useState({
    global_filter: '',
  });
  const [isLoading, setIsLoading] = useState(true);
  const [tableList, setTableList] = useState([]);
  const [filterData, setFilterData] = useState({
    total: 0,
    offset: 0,
    limit: limit,
  });
  const [switchUserDetails, setSwitchUserDetails] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);

  const getUserSwitchRequestsData = async (obj) => {
    setSelectedIds([])
    let forData = objectToFormData(obj);
    const response = await dispatch(fetchUserSwitchRequestData(forData));
    setTableList(response?.data?.swith_role_request || []);
    setFilterData({
      ...obj,
      total: response?.data?.result_count || 0,
    });
    setIsLoading(false);
  };

  useEffect(() => {
    const payload = {
      ...filterData,
      ...searchPayload,
    };
    getUserSwitchRequestsData(payload);
  }, []);

  const handleSearch = (e) => {
    let value = e?.target?.value;
    setSearchText(value);
    let time = timer;
    clearTimeout(time);
    time = setTimeout(() => {
      const updatedSearchPayload = { ...searchPayload, global_filter: value };
      setSearchPayload(updatedSearchPayload);
      const updatedFilterData = {
        ...filterData,
        offset: 0,
        ...updatedSearchPayload,
      };
      setIsLoading(true);
      setFilterData(updatedFilterData);
      getUserSwitchRequestsData(updatedFilterData);
    }, 800);
    setTimer(time);
  };

  const handelChangeSearch = (searchData) => {
    setIsLoading(true);
    let newData = filterData;
    setSearchPayload(searchData);
    newData = { ...newData, ...searchData, offset: 0 };
    setFilterData(newData);
    getUserSwitchRequestsData(newData);
  };

  const handelChangePagination = (offset) => {
    setIsLoading(true);
    let newData = { ...filterData, ...searchPayload };
    newData = { ...newData, offset: offset };
    setFilterData(newData);
    getUserSwitchRequestsData(newData);
  };



  // Bullk Approved
  const handleSelectAllChange = () => {
    setIsCheckAll((prev) => !prev);
    setSelectedIds(
      isCheckAll ? [] : tableList.map(({ request_id }) => request_id)
    );
  };

  const handleCheckboxChange = (request_id, isChecked) => {
    setSelectedIds((prev) => {
      const updatedSelectedIds = isChecked
        ? [...prev, request_id]
        : prev.filter((selectedId) => selectedId !== request_id);
      setIsCheckAll(updatedSelectedIds.length === tableList.length);
      return updatedSelectedIds;
    });
  };


  const header = [
    ...(loginUserRole === '1' ? [{ isSearch: false }] : []),
    {
      isSearch: true,
      searchInputName: 'name',
      title: 'Name',
    },
    {
      isSearch: true,
      searchInputName: 'current_role',
      title: 'Current Role',
      isSearchDropdown: true,
      dropdownOptions: {
        options: userRole,
        key: 'id',
        value: 'title',
      },
    },
    {
      isSearch: true,
      searchInputName: 'switch_to',
      title: 'Switch to',
      isSearchDropdown: true,
      dropdownOptions: {
        options: userRole,
        key: 'id',
        value: 'title',
      },
    },
    {
      isSearch: false,
      searchInputName: 'remarks',
      title: 'Remarks',
    },
    {
      isSearch: true,
      searchInputName: 'status',
      title: 'Status',
      isSearchDropdown: true,
      dropdownOptions: {
        options: [
          { id: '0', name: 'Pending' },
          { id: '1', name: 'Approved' },
          { id: '2', name: 'Rejected' },
        ],
        key: 'id',
        value: 'name',
      },
    },
    {
      isSearch: false,
      searchLable: 'View/Edit/Delete',
      title: 'Action',
    },
  ];

  const rowData = [];
  tableList?.forEach((elem, index) => {
    let obj = [
      ...(loginUserRole === "1" ? [
        {
          value: elem?.status === "Pending" ? (
            <div className="d-flex justify-content-center align-items-center">
              <input
                type="checkbox"
                className={`custom-checkbox ${selectedIds.includes(elem?.request_id)
                  ? 'activeChecked'
                  : 'activeUnchecked'
                  }`}
                onChange={(e) =>
                  handleCheckboxChange(elem?.request_id, e.target.checked)
                }
                checked={selectedIds.includes(elem?.request_id)}
              />
            </div>
          ) :
            index + 1,
        },
      ]
        : []),
      {
        value: <div className="pointer color-new-car">{elem.name}</div>,
      },
      {
        value: elem.current_role,
      },
      {
        value: elem.switch_to,
      },
      {
        value: elem?.remarks ? elem?.remarks : '-',
      },
      {
        value: <div className={paymentColor(elem?.status)}>{elem?.status}</div>,
      },
      {
        value: (
          <span className="action-icon-buttons">
            {viewAccess === '1' && (
              <Button
                btnStyle="light-outline"
                icon={<i className="bi bi-eye" />}
                className="me-2"
                onClick={() => {
                  navigate(
                    `/${memberType}/${loginUserRole === '1'
                      ? 'request-received'
                      : 'raised-request'
                    }/switch-user/view/${elem.request_id}`
                  );
                }}
                isSquare
              />
            )}
            {updateAccess === '1' &&
              elem?.status === 'Pending' &&
              loginUserRole === '0' && (
                <Button
                  btnStyle="light-outline"
                  icon={<img src={icons.edit} alt="edit" />}
                  className="me-2"
                  onClick={() => {
                    setOpenEditModal(true);
                    setSwitchUserDetails(elem);
                  }}
                  isSquare
                />
              )}
          </span>
        ),
      },
    ];

    rowData.push({ data: obj });
  });

  return (
    <>
      {openEditModal && (
        <UpdateSwitchUserModal
          onHide={() => setOpenEditModal(false)}
          switchUserDetails={switchUserDetails}
          getUserSwitchRequestsData={() =>
            getUserSwitchRequestsData({ ...filterData, ...searchPayload })
          }
        />
      )}
      <Card className="cps-20 cpe-20">
        <div className={`d-flex justify-content-between align-items-center ${selectedIds.length === 0 ? 'cpt-20 cpb-20' : ''}`}>
          {selectedIds.length === 0 ? (
            <>
              <div className="table-title">Switch User ({filterData?.total})</div>
              <div className="d-flex">
                <div style={{ width: '150px' }} className="me-3">
                  <SeachInput
                    placeholder="Search"
                    value={searchText}
                    onChange={handleSearch}
                    className="small-text-input"
                    iconClassName="small-search-icon"
                  />
                </div>


                <div className="d-flex me-3">
                  <ExportButton
                    exportAPI={fetchUserSwitchRequestData}
                    payload={objectToFormData({
                      ...filterData,
                      ...searchPayload,
                      export_status: 1,
                    })}
                  />
                </div>

              </div>
            </>
          ) :
            <BulkAction
              isCheckAll={isCheckAll}
              handleSelectAllChange={handleSelectAllChange}
              isLoading={isLoading}
              selectedIds={selectedIds}
              setSelectedIds={setSelectedIds}
              handleSendOtp={handleSendRBACRequestOTP}
              handleVerifyOtpRequest={handleRBACVerifyOtpRequest}
              typeTitle="Switch User"
              onSuccess={() => getUserSwitchRequestsData({ ...filterData, ...searchPayload })}
              api_type="SwitchUser"
            />
          }
        </div>

        <Table
          isLoading={isLoading}
          header={header}
          rowData={rowData}
          filterData={filterData}
          searchPayload={searchPayload}
          searchInputChange={handelChangeSearch}
          changeOffset={handelChangePagination}
          maxHeight="60vh"
          isOtherPagination
        />
      </Card>
    </>
  );
};

export default SwitchUser;
